<template>
	<drag 
		class="tool"
		:class="{ 'disabled': item.disabled }"
		:style="`border:1px solid ${item.select ? $appColors.success : 'transparent'}`"
		:transfer-data="item"
		:draggable="!item.disabled"
		@click="$emit('view', item)"
	>
		<button @click="$emit('view', item)">
			<img
				:src="item.image" 
				:alt="item.name"
				class="image"
				:class="{ 'disabled': item.disabled }">
			<p :style="`color:${$appColors.info}`">{{item.name}}</p>
		</button>
	</drag>
</template>
<script>
import { Drag } from 'vue-drag-drop';

export default {
	name: 'tool',
	components: {
		Drag,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.tool {
		align-items: center;
		background: map-get($colors, white);
		border-radius: 9px;
		border: 1px solid transparent;
		box-shadow: 0 0 4px 0 rgba(204, 204, 204, 0.38);
		cursor: move;
		display: flex;
		font-size: 10px;
		height: 81px;
		justify-content: center;
		margin-bottom: 19px;
		transition: all .2s ease-in-out;
		width: 100%;

		p {
			margin-bottom: 0;
		}

		&.disabled {
			p {
				color: map-get($colors, gray-slider);
			}
		}

		.image {
			&.disabled {
				filter: grayscale(100%);
    		opacity: 0.2;
			}
		}

		button {
			cursor: move;
		}
	}
</style>






// WEBPACK FOOTER //
// src/components/diagnosis/tool.vue